import "./gallery.css";
import "../../commoncss/pc_menu.css";
import "../../commoncss/link.css";
import "../../commoncss/loading.css";

import {getDevice} from "../../commonjs/device.js";
import {google} from "../../commonjs/google.js";
import {load_off} from "../../commonjs/load.js";
import smoothscroll from 'smoothscroll-polyfill';

import "@babel/polyfill";//promise　やarrayfromも変換

window.onload = function(){
    smoothscroll.polyfill();
    load_off();
    google();   
    const scroll_list = document.getElementById(`computer`).getElementsByTagName(`li`);
    const statement = document.getElementById(`statement`);
    const art_works = document.getElementById(`art_works`);
    const header = document.getElementsByTagName(`h1`);
    
    window.addEventListener(`scroll`,()=>{
       console.log(window.pageYOffset); 
    });
    
    
    class Scroll_page{
        constructor(direction,button){
            this.direction = direction;
            this.button = button;
            
            this.button.addEventListener(`click`,this,false);
        }
        
        handleEvent(){
            this.direction.scrollIntoView({
                behavior: `smooth`,
            });
        }
    }
    
    const head = new Scroll_page(header[0],scroll_list[0]);
    const article = new Scroll_page(statement,scroll_list[1]);
    const work_list = new Scroll_page(art_works,scroll_list[2]);
    
}